export const simmonsAttitudes = {
  displayOptions: {
    Apparel: {
      icon: '360-apparel-icon.png',
      sortBy: 'index',
    },
    Automobiles: {
      icon: '360-auto-icon.png',
      sortBy: 'index',
    },
    'Cell phones/smartphones': {
      icon: '360-cellphones-icon.png',
      sortBy: 'index',
    },
    'Consumer Privacy': {
      icon: '360-consumer-privacy-icon.png',
      sortBy: 'index',
    },
    'Diet and Health': {
      icon: '360-diet-health-icon.png',
      sortBy: 'index',
    },
    Environment: {
      icon: '360-environment-icon.png',
      sortBy: 'index',
    },
    Food: {
      icon: '360-food-icon.png',
      sortBy: 'index',
    },
    'Health & Medicine': {
      icon: '360-health-meds-icon.png',
      sortBy: 'index',
    },
    Internet: {
      icon: '360-internet-icon.png',
      sortBy: 'index',
    },
    Media: {
      icon: '360-media-icon.png',
      sortBy: 'index',
    },
    'Personal Finance': {
      icon: '360-personal-finance-icon.png',
      sortBy: 'index',
    },
    'Product Placement Movies': {
      icon: '360-prod-plcmnt-movies-icon.png',
      sortBy: 'index',
    },
    'Product Placement TV': {
      icon: '360-prod-plcmnt-tv-icon.png',
      sortBy: 'index',
    },
    Shopping: {
      icon: '360-shopping-icon.png',
      sortBy: 'index',
    },
    'Shopping Behavior': {
      icon: '360-shopping-behavior-icon.png',
      sortBy: 'index',
    },
    'Social Interactions': {
      icon: '360-soc-interaction-icon.png',
      sortBy: 'index',
    },
    'Social Media': {
      icon: '360-social-media-icon.png',
      sortBy: 'index',
    },
    Technology: {
      icon: '360-tech-icon.png',
      sortBy: 'index',
    },
    Travel: {
      icon: '360-travel-icon.png',
      sortBy: 'index',
    },
    'Video Games': {
      icon: '360-video-game-icon.png',
      sortBy: 'index',
    },
  },
  detailGroups: {
    Agree: {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    'Any Agree': {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    'Any Disagree': {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    Disagree: {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    'Neither Agree or Disagree': {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    'Strongly Agree': {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
    'Strongly Disagree': {
      Apparel: [],
      Automobiles: [],
      'Cell phones/smartphones': [],
      'Consumer Privacy': [],
      'Diet and Health': [],
      Environment: [],
      Food: [],
      'Health & Medicine': [],
      Internet: [],
      Media: [],
      'Personal Finance': [],
      'Product Placement Movies': [],
      'Product Placement TV': [],
      Shopping: [],
      'Shopping Behavior': [],
      'Social Interactions': [],
      'Social Media': [],
      Technology: [],
      Travel: [],
      'Video Games': [],
    },
  },
};
export const mriAttitudes = {
  displayOptions: {
    Automotive: {
      icon: '360-mri-auto-icon.png',
      sortBy: 'index',
    },
    'Buying Styles': {
      icon: '360-mri-buying-style-icon.png',
      sortBy: 'index',
    },
    'Fashion & Style': {
      icon: '360-mri-fashion-icon.png',
      sortBy: 'index',
    },
    Finance: {
      icon: '360-mri-finance-icon.png',
      sortBy: 'index',
    },
    Food: {
      icon: '360-mri-food-icon.png',
      sortBy: 'index',
    },
    General: {
      icon: '360-mri-general-icon.png',
      sortBy: 'index',
    },
    Health: {
      icon: '360-mri-health-icon.png',
      sortBy: 'index',
    },
    'Internet/Online': {
      icon: '360-mri-internet-icon.png',
      sortBy: 'index',
    },
    'More TV Watching': {
      icon: '360-mri-tv-watching-icon.png',
      sortBy: 'index',
    },
    Technology: {
      icon: '360-mri-tech-icon.png',
      sortBy: 'index',
    },
    'Vacation Travel': {
      icon: '360-mri-travel-icon',
      sortBy: 'index',
    },
  },
  detailGroups: {
    'Agree Completely': {
      Automotive: [],
      'Buying Styles': [],
      'Fashion & Style': [],
      Finance: [],
      Food: [],
      General: [],
      Health: [],
      'Internet/Online': [],
      'More TV Watching': [],
      Technology: [],
      'Vacation Travel': [],
    },
    'Agree Somewhat': {
      Automotive: [],
      'Buying Styles': [],
      'Fashion & Style': [],
      Finance: [],
      Food: [],
      General: [],
      Health: [],
      'Internet/Online': [],
      'More TV Watching': [],
      Technology: [],
      'Vacation Travel': [],
    },
    'Disagree Somewhat': {
      Automotive: [],
      'Buying Styles': [],
      'Fashion & Style': [],
      Finance: [],
      Food: [],
      General: [],
      Health: [],
      'Internet/Online': [],
      'More TV Watching': [],
      Technology: [],
      'Vacation Travel': [],
    },
    'Disagree Completely': {
      Automotive: [],
      'Buying Styles': [],
      'Fashion & Style': [],
      Finance: [],
      Food: [],
      General: [],
      Health: [],
      'Internet/Online': [],
      'More TV Watching': [],
      Technology: [],
      'Vacation Travel': [],
    },
  },
};


export const mediaBrands = {
  detail: [],
};

export const simmonsDemographics = {
  displayOptions: {
    Age: 'index',
    'Census Region': 'index',
    'Children in Household': 'index',
    Education: 'index',
    'Employment Status': 'index',
    Ethnicity: 'percent',
    Gender: 'percent',
    'Household Income': 'index',
    'Marital Status': 'index',
    'Political Outlook': 'index',
    Race: 'index',
    Residence: 'index',
  },
  detailGroups: {
    Age: [],
    'Census Region': [],
    'Children in Household': [],
    Education: [],
    'Employment Status': [],
    Ethnicity: [],
    Gender: [],
    General: [],
    'Household Income': [],
    'Marital Status': [],
    'Political Outlook': [],
    Race: [],
    Residence: [],
  },
};


export const mriDemographics = {
  displayOptions: {
    Age: 'percent',
    'Census Region': 'percent',
    'Children in Household': 'percent',
    Education: 'percent',
    'Employment Status': 'percent',
    Ethnicity: 'percent',
    Gender: 'percent',
    'Household Income': 'percent',
    'Marital Status': 'percent',
    Occupation: 'percent',
    'Political Outlook': 'percent',
    Race: 'percent',
  },
  detailGroups: {
    Age: [],
    'Census Region': [],
    'Children in Household': [],
    Education: [],
    'Employment Status': [],
    Ethnicity: [],
    Gender: [],
    General: [],
    'Household Income': [],
    'Marital Status': [],
    Occupation: [],
    'Political Outlook': [],
    Race: [],
  },
};

export const simmonsProfiles = {
  displayOptions: {
    'ATTITUDES (GENERAL) - ANY AGREE': 'index',
    'SELF-CONCEPTS - ANY AGREE': 'index',
    'PAST FINANCIAL OUTLOOK':
      'index',
    'FUTURE FINANCIAL OUTLOOK':
      'index',
    'PURCHASE A BIG TICKET ITEM':
      'index',
    'PURCHASE A MEDIUM TICKET ITEM':
      'index',
    'CONSUMER CONFIDENCE SCALE(1-8)': 'index',
    'PROPENSITY TO BUY SCALE(1-8)': 'index',
  },
  detailGroups: {
    'ATTITUDES (GENERAL) - ANY AGREE': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: '360-generic-profile-icon.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'SELF-CONCEPTS - ANY AGREE': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PAST FINANCIAL OUTLOOK': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'FUTURE FINANCIAL OUTLOOK': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PURCHASE A BIG TICKET ITEM': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PURCHASE A MEDIUM TICKET ITEM': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'CONSUMER CONFIDENCE SCALE(1-8)': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PROPENSITY TO BUY SCALE(1-8)': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
  },
};


export const mriProfiles = {
  displayOptions: {
    'ATTITUDES (GENERAL)': 'index',
    'PAST FINANCIAL OUTLOOK': 'index',
    'FUTURE FINANCIAL OUTLOOK': 'index',
    'PAST ECONOMIC OUTLOOK OF COUNTRY': 'index',
    'FUTURE ECONOMIC OUTLOOK OF COUNTRY': 'index',
    'PUBLIC ACTIVITIES IN LAST 12 MONTHS': 'index'
  },
  detailGroups: {
    'ATTITUDES (GENERAL)': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: '360-generic-profile-icon.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PAST FINANCIAL OUTLOOK': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'FUTURE FINANCIAL OUTLOOK': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PAST ECONOMIC OUTLOOK OF COUNTRY': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'FUTURE ECONOMIC OUTLOOK OF COUNTRY': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
    'PUBLIC ACTIVITIES IN LAST 12 MONTHS': [
      {
        label: 'N/A',
        value: {
          pct: 'N/A%',
          icon: 'none.png',
          index: 'N/A',
          sample: 'N/A',
          weighted: 'N/A',
        },
      },
    ],
  },
};

